import {
  HotelDetailURLParams,
  UrlaubURLParams,
  HotelDetailURLParamsOnly,
  allUniqueParamNames,
} from "../Types/URLParameters";

export function getFilterKey(
  searchParams: UrlaubURLParams | HotelDetailURLParams,
  ignoreParams: string[] = []
): string {
  const parts: string[] = [];

  for (const param of allUniqueParamNames) {
    // Skip the 'page' parameter and any parameters in the ignoreParams array
    if (
      param !== HotelDetailURLParamsOnly.PAGE &&
      !ignoreParams.includes(param)
    ) {
      const value = (searchParams as Record<string, unknown>)[param as string];
      if (value != null && value !== "") {
        parts.push(`${param}:${encodeURIComponent(String(value))}`);
      }
    }
  }

  return parts.join("|");
}
